import React, { useRef } from 'react';

import { AppSelectors } from '../../../../../selectors';
import { useSelector } from '../../../../../selectors/useSelector';
import PremiumCompare from '../../../../PremiumCompare';
import PremiumFeatureSummary from '../../../../PremiumFeatureSummary';

const FreemiumPay = () => {
  const premiumCompareRef = useRef<HTMLDivElement>(null);
  const isScreenDesktop = useSelector((state) => AppSelectors.makeIsScreenXlGTE(state));
  const {
    properties: {
      currentProperty: {
        freemium: { isInBuildingGroup = false },
      },
    },
  } = useSelector((state) => state);

  return (
    <div data-testid="FreemiumPay">
      <PremiumFeatureSummary
        premiumCompareRef={premiumCompareRef}
        hideCompareAndLearnMore={!isScreenDesktop}
        isInBuildingGroup={isInBuildingGroup}
      />
      <div ref={premiumCompareRef}>
        <PremiumCompare />
      </div>
    </div>
  );
};

export default FreemiumPay;
